import { NotificationStateI, getNotificationTypes, notificationTypes } from "./notificationTypes";

export const initialState: NotificationStateI = {
  notification: {
    message : "",
    type    : "info",
  },
};

const ACTION_REDUCER = {
  [notificationTypes.NOTIFY]: (state: NotificationStateI, { payload }: getNotificationTypes) => ({
    ...state,
    notification: {
      ...state.notification,
      ...payload,
    },
  }),
  [notificationTypes.CLEAR_NOTIFICATION_DATA]: (state: NotificationStateI, { payload }: getNotificationTypes) => ({
    ...state,
    notification: payload,
  }),
};

const reducer = (state: NotificationStateI = initialState, action: getNotificationTypes) => {
  const actionReducer = ACTION_REDUCER[action.type];

  return actionReducer ? actionReducer(state, action) : state;
};

export default reducer;
